import { createSignal } from "solid-js"
import { samePosition } from "../../lib/core/tile_position_xy/samePosition"
import type { TilePositionXY } from "../../lib/core/tile_position_xy/TilePositionXY.type"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

/**
 * The root data store for selection is multi-select.
 * 
 * example usage:
 * export const [getSelectedPositionList, setSelectedPositionList] = useSelectedPositionListSignal(engine)
 */
export const useHoveredPositionSignal = createSharedCachedFactory((
  // engine: Engine
) => {

  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<TilePositionXY | null>(null, {
    equals: samePosition,
  })

  return signal
})


